module.exports = __webpack_public_path__ + "static/media/fundo.5a4cd484.png";